import React, { useState } from "react";

import "../css/LynxStyle.css";

const WaterIntakeCalculator = () => {
  const [weight, setWeight] = useState("");
  const [result, setResult] = useState(null);

  const CalculateWaterIntake = () => {
    if (!weight || Number(weight) <= 0) {
      return;
    }
    const liters = Number(weight) * 0.033;
    const glasses = Math.round((liters * 1000) / 250);

    setResult({ liters: liters.toFixed(2), glasses });
  };

  return (
    <div className="container">
      <br />
      <br />
      <h3 className="text-white">💧 Water Intake Calculator</h3>
      <div className="lynx-page-card">
        <form>
          <div className="form-group">
            <label htmlFor="weight" className="text-white">
              Weight (kg):
            </label>
            <input
              type="number"
              value={weight}
              onChange={(e) => setWeight(e.target.value)}
              className="form-control"
              id="weight"
              placeholder="Enter weight"
            />
          </div>
          <div className="text-center mt-3">
            <button
              type="button"
              onClick={CalculateWaterIntake}
              className="btn-lynx w-100"
            >
              🚰 Calculate
            </button>
          </div>
        </form>
        {result && (
          <div className="smsgpt text-center mt-3 fs-5">
            Drink about {result.liters} liters of water a day
            <br />
            <small>That's roughly {result.glasses} glasses (250ml each) 🥤</small>
          </div>
        )}
      </div>
    </div>
  );
};

export default WaterIntakeCalculator;
